import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

export const BreadcrumbPortal = ({ children }) => {
  const [domReady, setDomReady] = useState(false)

  useEffect(() => {
    const container = document.getElementById('breadcrumb-first-level')
    const handleContentLoaded = () => {
      setDomReady(true)
    }
    if (container) {
      setDomReady(true)
    } else {
      document.addEventListener('DOMReady', handleContentLoaded)
    }
    return () => {
      document.removeEventListener('DOMReady', handleContentLoaded)
    }
  }, [])

  return domReady
    ? createPortal(children, document.getElementById('breadcrumb-first-level'))
    : null
}
